import { render } from "./AboutClients.vue?vue&type=template&id=3920b6ed&scoped=true"
import script from "./AboutClients.vue?vue&type=script&lang=js"
export * from "./AboutClients.vue?vue&type=script&lang=js"

import "./AboutClients.vue?vue&type=style&index=0&id=3920b6ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3920b6ed"]])

export default __exports__